<template>
  <div class="item-container">
    <ServiceHeader
      v-if="getSelectedItineraries"
      :tourHubItem="tourHubItem" 
      @clicked="toggleExpand" 
      :showAll="showAll"
    />
    <div 
      v-if="dropdown === true && !tourHubItem.isStaticCard && getSelectedItineraries" 
      class="item-dropdown item-dropdown-container"
    >
      <Accommodation 
        v-if="tourHubItem.serviceType === 'Accommodation'"
        :accommodationItem="tourHubItem"
        :tourTravellers="passengerInfo.travellers"
      />
      <Transport 
        v-if="tourHubItem.serviceType === 'Transport'"
        :transportItem="tourHubItem"
        :tourTravellers="passengerInfo.travellers"
      />
      <Experience
        v-if="tourHubItem.serviceType === 'Experience'"
        :experienceItem="tourHubItem"
        :tourTravellers="passengerInfo.travellers"
      />
    </div>
  </div>
</template>

<script>
import ServiceHeader from './header.vue'
import Accommodation from './accommodation.vue'
import Experience from './experience.vue'
import Transport from './transport.vue'

export default {
  components: {
    ServiceHeader,
    Accommodation,
    Experience,
    Transport,
  },
  props: {
    tourHubItem: {
      type: Object
    },
    passengerInfo: {
      type: Object
    },
    showAll: {
      type: Boolean
    },
    selectedItineraries: {
      type: Array
    }
  },
  data () {
    return {
      dropdown: false,
      overideDropdown: false,
      moduleHeaderDropdown: false,
      isHeaderVisible: false,
    }
  },
  watch: {
    showAll() {
      this.overideDropdown = false
      if (this.overideDropdown === false) {
        if (this.showAll === true) {
          this.dropdown = true
        } else {
          this.dropdown = false
        }
      }
    }
  },
  computed: {
    getSelectedItineraries () {
      return this.selectedItineraries.includes(this.tourHubItem.mainBookingId)
    },
  },
  methods: {
    toggleExpand(value) {
      this.overideDropdown = true
      this.dropdown = value;
    },
  }
};
</script>

<style lang="scss">
@import "../../styles.scss";
.item-dropdown-container {
  padding: 40px;
}
</style>